<template>
  <section class="lms-container" data-id="<s:property value='subscription.id' />">
    <div class="content">
      <div class="breadcrumb-content">
        <ul class="breadcrumb">
          <li>
            <a href="#">Início</a>
          </li>
          <li>
            <a>{{courseName}}</a>
          </li>
          <li>
            <a>Painel do curso</a>
          </li>
        </ul>
      </div>

      <div class="title-section-content">
        <h3>Painel do curso: {{course.name}}</h3>
      </div>

      <div class="student-panel <s:property value='#admin' />">
        <!-- coordinators -->
        <div class="box-content course-dashboard-content">
          <div class="text-content">
            <h3>Nome do curso</h3>
            <span class="coordinators-list">
              <strong>Coordenadores:</strong> lista de coordenadores
            </span>

            <span class="course-progress loading-placeholder" style="display: block;">
              <span class="progress-info">
                <span class="progress-label">progresso</span>
                <span class="progress-number">0%</span>
              </span>
              <span class="progress-bar">
                <span class="actual-progress" style="width: 0%;"></span>
              </span>
            </span>
          </div>

          <div class="image-content">
            <ul>
              <s:iterator value="coordinators">
                <li>
                  <figure>
                    <img src="#" alt="coord">
                  </figure>
                </li>
              </s:iterator>
            </ul>
          </div>
        </div>

        <!-- video tracking -->
        <div class="box-content">
          <div v-if="!continueVideo">
            <div class="text-content">
              <p>
                <i class="icon icon-play-folder"></i> Aula - continue a assistir
              </p>
              <h4>
                <s:property value="tracking.course.name"/>-
                Aula:
                <s:property value="tracking.lesson.title"/>(parte
                <s:property value="tracking.video.partNumber"/>)
              </h4>
            </div>
            <div class="link-content">
              <s:a
                cssClass="go-to-link"
                value="/aluno/turma/%{tracking.klass.id}/aula/%{tracking.lesson.id}/%{tracking.video.id}"
              >Continuar</s:a>
            </div>
          </div>

          <div v-else>
            <div class="text-content">
              <p>
                <i class="icon icon-play-folder"></i> Aulas do curso
              </p>
              <h4>Você ainda não assistiu nenhuma aula do curso.</h4>
            </div>
            <div class="link-content">
              <a href="#" class="go-to-link">Iniciar curso</a>
            </div>
          </div>
        </div>

        <!-- messages -->
        <div class="box-content">
          <div v-if="lastMessage">
            <div class="text-content">
              <p class="label-has-icon">
                <span class="icon icon-chat-46"></span>Plantão de dúvidas - Última mensagem respondida
              </p>
              <h4>
                <s:property value="lastMessage.parent.message"/>
              </h4>
            </div>

            <div class="link-content">
              <s:a
                cssClass="go-to-link"
                value="/aluno/turma/%{klass.id}/plantao-de-duvidas"
              >ver mensagens</s:a>
            </div>
          </div>
          <div v-else>
            <div class="text-content">
              <p class="label-has-icon">
                <span class="icon icon-chat-46"></span>Plantão de dúvidas
              </p>
              <h4>Você não possui nenhum mensagem respondida.</h4>
            </div>
            <div class="link-content"></div>
          </div>
        </div>

        <!-- forum -->
        <div class="box-content">
          <div v-if="lastTopic">
            <div class="text-content">
              <p class="label-has-icon">
                <span class="icon icon-multiple-11"></span> Fórum - Última participação
              </p>
              <h4>
                <s:property value="lastTopic.title"/>
              </h4>
            </div>

            <div class="link-content">
              <a class="go-to-link" href="#">ir para tópico</a>
            </div>
          </div>
          <div v-else>
            <div class="text-content">
              <p class="label-has-icon">
                <span class="icon icon-multiple-11"></span> Fórum
              </p>
              <h4>Você não possui nenhuma participação no fórum ainda.</h4>
            </div>
            <div class="link-content"></div>
          </div>
        </div>

        <!-- notices -->
        <div class="box-content alternative notices-dashboard-content">
          <div class="title-section-content">
            <h3>Mural de avisos</h3>
          </div>

          <ul id="notices-list">
            <div class="placeholder-message">
              <h5 style="font-size: 16px;">Você não possui nenhum aviso</h5>
            </div>
          </ul>

          <div id="notices-pagination" class="text-center"></div>
        </div>

        <!-- teachers -->
        <div class="box-content alternative teachers-dashboard-content">
          <div class="title-section-content">
            <h3>Corpo docente</h3>
          </div>

          <ul id="teachers-list">
            <div class="placeholder-message">
              <h5 style="font-size: 16px;">Não existe nenhum corpo docente</h5>
            </div>
          </ul>

          <div id="teachers-pagination" class="text-center"></div>
        </div>

        <!-- Annotations -->
        <div class="box-content">
          <div v-if="lastAnnotation">
            <div class="text-content">
              <p class="label-has-icon">
                <i class="icon icon-single-copy-04"></i> Anotação - mais recente
              </p>
              <h4>
                <s:property value="lastAnnotation.video.lesson.title"/>-
                Vídeo
                <s:property value="lastAnnotation.video.partNumber"/>
              </h4>
            </div>
            <div class="link-content">
              <a class="go-to-link" href="#">ir para anotação</a>
            </div>
          </div>
          <div v-else>
            <div class="text-content">
              <p class="label-has-icon">
                <span class="icon icon-single-copy-04"></span> Anotações
              </p>
              <h4>Você ainda não possui nenhuma anotação</h4>
            </div>

            <div class="link-content"></div>
          </div>
        </div>

        <!-- activities -->
        <div class="box-content">
          <div v-if="!hasActivities">
            <div class="text-content">
              <p class="label-has-icon">
                <i class="icon icon-todo"></i> Atividade complementar
              </p>
              <h4>Você não possui nenhuma atividade complementar</h4>
            </div>
            <div class="link-content"></div>
          </div>

          <div v-else-if="extraTracking">
            <div class="text-content">
              <p class="label-has-icon">
                <i class="icon icon-todo"></i> Atividade complementar - continuar onde parei
              </p>
              <h4>título da atividade complementar</h4>
            </div>
            <div class="link-content">
              <a class="go-to-link" href="#">ir para atividade</a>
            </div>
          </div>

          <div v-else>
            <div class="text-content">
              <p class="label-has-icon">
                <i class="icon icon-todo"></i> Atividade complementar
              </p>
              <h4>Você ainda não assistiu nenhuma aula das atividades complementares</h4>
            </div>
            <div v-if="!isAdmin">
              <div class="link-content">
                <a href="#" class="go-to-link">Ir para atividades</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
	data() {
		return {
			courseName:'Premiapão university',
			continueVideo: true,
			message: '',
			showMessage: false,
		};
	}, 
	computed: {
		course: function() {
			return this.$store.getters.course;
		}
	},
	components: {
	},
	methods: {
		
	},
	created() {
		
	}
};
</script>
